import axiosClient from "./axios";
import { API } from "./types";

const findAll = async () => {
  const response = await axiosClient.get<API.getAll>("po-health-specials/list");
  return response.data;
};

const findDetail = async (id: number) => {
  const response = await axiosClient.get<API.ItemDetailResponse>(
    `po-health-specials/detail?id=${id}`
  );
  return response.data;
};

const update = async (data: any) => {
  axiosClient.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  const response = await axiosClient.post<void>(
    "po-health-specials/update",
    data
  );
  return response;
};

const getPredict = async (data: any) => {
  return await axiosClient.post<API.PredictResponse>(
    "user/toshiba-ai/get-prediction",
    data
  );
};

const getResult = async (req: API.ResultRequest) => {
  // ppw("getResult().req", req);
  const res = await axiosClient.get<API.ResultResponse>(
    "user/toshiba-ai/get-result-advice",
    {
      params: { ...req },
    }
  );
  return res.data;
};

const readAdvicesApi = async (req: API.ReadAdvicesRequest) => {
  // ppw("getResult().req", req);
  const res = await axiosClient.get<API.ReadAdvicesResponse>(
    "user/toshiba-ai/get-advice-record",
    {
      params: { ...req },
    }
  );
  return res.data;
};

const createReactionApi = async (req: API.CreateReactionRequest) => {
  // ppw("getResult().req", req);
  const res = await axiosClient.post<API.CreateReactionResponse>(
    "user/toshiba-ai/advice/reaction",
    req
  );
  return res.data;
};

const deleteRecordApi = async (req: API.DeleteRecordRequest) => {
  // ppw("getResult().req", req);
  const res = await axiosClient.post<API.DeleteRecordResponse>(
    "po-health-specials/delete",
    req
  );
  return res.data;
};

const ApiServices = {
  findAll,
  findDetail,
  update,
  getPredict,
  getResult,
  readAdvicesApi,
  createReactionApi,
  deleteRecordApi,
};

export default ApiServices;
